import { darkTheme, lightTheme } from '@/assets/theme';
import DateFnsAdapter from '@date-io/date-fns';
import '@mdi/font/css/materialdesignicons.css';
import { enAU } from 'date-fns/locale';
import { createVuetify } from 'vuetify';
import { aliases, md } from 'vuetify/iconsets/md';
import { mdi } from 'vuetify/iconsets/mdi';

export const vuetify = createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      dark: darkTheme,
      light: lightTheme,
    },
  },
  date: {
    adapter: DateFnsAdapter,
    locale: { en: enAU },
  },
  icons: {
    defaultSet: 'md',
    aliases,
    sets: { md, mdi },
  },
});
